/**
 * nr-media-dots — barre di progresso sotto il carosello mobile della
 * galleria PDP (snippets/media-gallery.liquid, caso "Desktop grid + Mobile
 * Hidden thumbnail"). La pagination nativa dello slide-with-thumbs e'
 * fissa via JS del tema su type "custom" (testo "1/N", vedi assets/theme.js,
 * non modificabile) e un solo elemento .swiper-pagination puo' essere legato
 * a quel renderer: queste barre sono quindi un secondo indicatore,
 * autonomo, che si aggancia dall'esterno all'istanza Swiper gia' creata
 * (element.globalSlide) senza toccare file JS non-NR.
 */
class NrMediaDots extends HTMLElement {
  connectedCallback() {
    this.dots = Array.from(this.querySelectorAll(".nr-media-dots__dot"));
    if (!this.dots.length) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener("click", () => this.swiper?.slideTo(index));
    });

    this.attachToSwiper();
  }

  attachToSwiper() {
    // L'istanza Swiper (this.carousel.globalSlide) viene creata nel
    // constructor di slide-with-thumbs: puo' non essere ancora pronta al
    // primo tentativo, si ripete finche' non lo e'.
    const carousel = this.previousElementSibling;
    const swiper = carousel?.globalSlide;
    if (!swiper) {
      requestAnimationFrame(() => this.attachToSwiper());
      return;
    }
    this.swiper = swiper;
    this.update();
    swiper.on("slideChange", () => this.update());
  }

  update() {
    if (!this.swiper) return;
    const active = this.swiper.activeIndex || 0;
    this.dots.forEach((dot, index) => {
      dot.classList.toggle("is-active", index === active);
    });
  }
}

if (!customElements.get("nr-media-dots")) {
  customElements.define("nr-media-dots", NrMediaDots);
}
